import React, { useCallback, useEffect } from 'react';
import { defaultLang, setLanguage, useLang } from './Metronici18n';
import { IntlProvider } from 'react-intl';
// import "react-int"
// import '@formatjs/intl-relativetimeformat/polyfill';
// import '@formatjs/intl-relativetimeformat/locale-data/en';
// import '@formatjs/intl-relativetimeformat/locale-data/de';
// import '@formatjs/intl-relativetimeformat/locale-data/es';
// import '@formatjs/intl-relativetimeformat/locale-data/fr';
// import '@formatjs/intl-relativetimeformat/locale-data/ja';
// import '@formatjs/intl-relativetimeformat/locale-data/zh';
// import '@formatjs/intl-relativetimeformat/locale-data/en-MY';

import deMessages from './messages/de';
import enMessages from './messages/en';
import esMessages from './messages/es';
import frMessages from './messages/fr';
import jaMessages from './messages/ja';
import twMessages from './messages/zh-TW';
import cnMessages from './messages/zh-CN';
import thMessages from './messages/th';
import msMessages from './messages/ms';
import idMessages from './messages/id';
import filMessages from './messages/fil';
import kmMessages from './messages/km';
import myMessages from './messages/my';
import { useSelector } from 'react-redux';
import { axiosUser } from '@axios/axiosInstances';
import { BACKEND_URL } from '../../config';

//language codes are based on the standard locale codes
//https://www.alchemysoftware.com/livedocs/ezscript/Topics/Catalyst/Language.htm
const allMessages = {
  de: deMessages,
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  ja: jaMessages,
  'zh-TW': twMessages,
  'zh-CN': cnMessages,
  th: thMessages,
  ms: msMessages,
  id: idMessages,
  fil: filMessages,
  km: kmMessages,
  my: myMessages
};

export function I18nProvider({ children }) {
  const user = useSelector(state => state.auth.user);
  const shop = useSelector(state => state.auth.shop);
  const locale = useLang();
  const messages = allMessages[locale];

  const compareLanguages = useCallback(async () => {
    try {
      //if the langauge in database doesn't match, set the language in the local machine to the saved language
      if (user?.setting?.lang && user.setting.lang !== locale) {
        setLanguage(user.setting.lang);
      } else if (user && !user.setting) {
        //if shopUserSetting collection doesn't exist upsert it based on the local machine's language
        await axiosUser.put(`/shopUser/setting/`, {
          lang: locale || defaultLang,
          shopUser: user.shopUserId
        });
      } else if (!user && shop && shop.defaultLanguage && shop.defaultLanguage !== locale) {
        //if the user is not logged in, but the shop has a default language, set the language to the shop's default language
        setLanguage(shop.defaultLanguage);
      }
    } catch (err) {
      console.log(err);
    }
  }, [user, shop, locale]);

  useEffect(() => {
    compareLanguages();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, shop]);

  return (
    //default locale fixes a bug when the app returns a wrong locale while using cn and my
    <IntlProvider locale={locale} messages={messages} defaultLocale={locale}>
      {children}
    </IntlProvider>
  );
}
